import React, {Component} from 'react';
import $ from 'jquery';
import '../App.css';


import {Trans, withTranslation} from "react-i18next";
import ArrowDownWhite from "../img/ArrowDownWhite.svg";
import {Link as LinkScroll} from "react-scroll";

class HomeSliderTop extends Component {

    constructor(props) {
        super(props);

        this.state = {
            height: '100%',
            isMobile: false
        };

        this.onWindowResize = this.onWindowResize.bind(this);
    }


    componentDidMount() {
        $(window).on('resize', this.onWindowResize).trigger('resize');
    }

    componentWillUnmount() {
        $(window).off('resize', this.onWindowResize);
    }

    onWindowResize() {
        let headerHeight = $('header.header').height();

        // 767 px = tentýž zlom, na kterém přepíná zbytek webu (App.less)
        this.setState({
            height: $(window).height() - headerHeight,
            isMobile: $(window).width() <= 767
        });
    }


    render() {
        const { t, headline, years, episodes, genre, image, imageMobile, colorMode} = this.props;

        // Na telefonu se ze šířkového vizuálu ořezem ztratí volná plocha vedle postav,
        // do které patří název — proto se sahá po verzi na výšku. Když projekt mobilní
        // variantu nemá (starší záznamy), zůstává vše jako dřív.
        const pozadi = (this.state.isMobile && imageMobile) ? imageMobile : image;

        return (
            <div className="container-fluid" id="slider-top"
                 style={{backgroundImage: `url(${pozadi})`, height: this.state.height}}>
                <div className="container slider-top-container">
                    <div className="slider-top-text">
                        <h1 className={colorMode === "dark" ? "black-text" : ""}>{headline}</h1>
                        <span className={colorMode === "dark" ? "black-text" : ""}>{`${years}  |  ${t('episodes', {count: parseInt(episodes)})}  |  ${genre}`}</span>

                        <LinkScroll className="navbar-brand" to="project_0"
                                    spy={true}
                                    smooth={true}
                                    offset={-250}
                                    t={t}
                                    duration= {500}>
                                    <button><Trans i18nKey={"more"} defaults={"MORE"} /> </button>
                        </LinkScroll>


                    </div>

                    <div className="slider-bottom-arrow">
                        <img alt="arrow" src={ArrowDownWhite}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(HomeSliderTop);
